import React, { useState } from 'react';
import { useLocation, Link, NavLink } from 'react-router-dom';
import { useLang } from '../context/LanguageContext';
import { Menu, X, Globe, Building2 } from 'lucide-react';
import GetStartedModal from './GetStartedModal';

const Header = () => {
  const { t, lang, setLang, isRTL } = useLang();
  const [open, setOpen] = useState(false);
  const [gsOpen, setGsOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { to: '/', label: t.nav.home },
    { to: '/about', label: t.nav.about },
    { to: '/services', label: t.nav.services },
    { to: '/opportunities', label: t.nav.opportunities },
    { to: '/tender-support', label: t.nav.tenderSupport },
    { to: '/jobs', label: t.nav.jobs },
    { to: '/contact', label: t.nav.contact }
  ];

  const langOptions = [ { c: 'en', l: 'EN' }, { c: 'ar', l: 'العربية' }, { c: 'zh', l: '中文' } ];

  return (
    <>
    <header className="bg-[#FBF9F2] border-b border-[#E8E1CE] sticky top-0 z-40">
      <div className="sib-container flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3" onClick={() => setOpen(false)}>
          <div className="w-11 h-11 rounded-md bg-[#0B5D3B] flex items-center justify-center">
            {/* Bridge icon */}
            <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#D4A840" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M3 18h18" />
              <path d="M5 18v-3" />
              <path d="M19 18v-3" />
              <path d="M5 15c2.5-4 4.5-6 7-6s4.5 2 7 6" />
              <path d="M8 13v5" />
              <path d="M12 11v7" />
              <path d="M16 13v5" />
            </svg>
          </div>
          <div className="leading-tight">
            <div className="text-[#0B5D3B] font-bold text-[15px] tracking-tight">{t.common.brand}</div>
            <div className="text-[#D4A840] text-[11px] font-medium tracking-wide">{t.common.brandSub}</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {navItems.map(n => (
            <NavLink key={n.to} to={n.to} end={n.to === '/'} className={({ isActive }) => `text-[15px] font-medium transition-colors ${isActive ? 'text-[#0B5D3B]' : 'text-[#33473d] hover:text-[#0B5D3B]'}`}>{n.label}</NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div className="hidden md:flex items-center border border-[#E8E1CE] rounded-md overflow-hidden">
            {langOptions.map(o => (
              <button key={o.c} onClick={() => setLang(o.c)} className={`px-2.5 py-1.5 text-xs font-semibold transition-colors ${lang === o.c ? 'bg-[#0B5D3B] text-white' : 'bg-transparent text-[#33473d] hover:bg-[#f0ead8]'}`}>{o.l}</button>
            ))}
          </div>
          <button onClick={() => setGsOpen(true)} className="btn-gold hidden md:inline-flex text-[14px] px-4 py-2">{t.nav.getStarted}</button>
          <button className="lg:hidden p-2 text-[#0B5D3B]" onClick={() => setOpen(!open)} aria-label="menu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-[#E8E1CE] bg-[#FBF9F2]">
          <div className="sib-container py-4 flex flex-col gap-3">
            {navItems.map(n => (
              <NavLink key={n.to} to={n.to} end={n.to === '/'} onClick={() => setOpen(false)} className={({ isActive }) => `text-[15px] font-medium py-1.5 ${isActive ? 'text-[#0B5D3B]' : 'text-[#33473d]'}`}>{n.label}</NavLink>
            ))}
            <div className="flex items-center gap-2 pt-2">
              <Globe size={16} className="text-[#0B5D3B]" />
              {langOptions.map(o => (
                <button key={o.c} onClick={() => setLang(o.c)} className={`px-3 py-1.5 text-xs font-semibold rounded ${lang === o.c ? 'bg-[#0B5D3B] text-white' : 'bg-[#f0ead8] text-[#33473d]'}`}>{o.l}</button>
              ))}
            </div>
            <button onClick={() => { setGsOpen(true); setOpen(false); }} className="btn-gold mt-2 justify-center">{t.nav.getStarted}</button>
          </div>
        </div>
      )}
    </header>
    <GetStartedModal open={gsOpen} onClose={() => setGsOpen(false)} pageSource={(location.pathname.replace(/^\//,'').split('/')[0]) || 'home'} />
    </>
  );
};

export default Header;
